import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDriverRatingSummary } from '../../types/api/response/driverratingsresponse';
import { IDriverRatingsState } from '../../types/store';

const initialState: IDriverRatingsState = {
  drivers: [],
  totalElements: 0,
  pagination: { page: 0, size: 20 },
  selectedDriver: null,
};

const driverRatingsSlice = createSlice({
  name: 'driverRatingsSlice',
  initialState,
  reducers: {
    setDrivers: (
      state,
      action: PayloadAction<{ content: IDriverRatingSummary[]; totalElements: number }>,
    ) => {
      state.drivers = action.payload.content;
      state.totalElements = action.payload.totalElements;
    },
    setSelectedDriver: (state, action: PayloadAction<IDriverRatingSummary | null>) => {
      state.selectedDriver = action.payload;
    },
    setPagination: (state, action: PayloadAction<{ page: number; size: number }>) => {
      state.pagination = action.payload;
    },
    resetDriverRatings: () => initialState,
  },
});

export const { setDrivers, setSelectedDriver, setPagination, resetDriverRatings } =
  driverRatingsSlice.actions;

export default driverRatingsSlice.reducer;
